import {
  Box,
  HStack,
  VStack,
  Button,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  PinInput,
  PinInputField
} from '@chakra-ui/react'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Layout, Loader, SettingBox } from '../../components'
import { ErrorMessage } from '../../components/form'
import useResetStore from '../../state/Reset.store'

const Security = () => {
  const { email } = JSON.parse(localStorage.getItem('auth') || '')?.user

  const [sendOTP, loading, changePin] = useResetStore((state) => [
    state.sendOTP,
    state.loading,
    state.changePin
  ])
  const { isOpen, onOpen, onClose } = useDisclosure()

  const submit = async () => {
    try {
      await sendOTP(email)
      onOpen()
    } catch (error) {
      console.log('error')
    }
  }

  const {
    handleSubmit,
    control,
    watch,
    formState: { errors }
  } = useForm()

  const onSubmit = async (values) => {
    try {
      await changePin(values)
      onClose()
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Layout noMb title="Security">
      <Loader text="Verification in progress..." loading={loading} />
      <SettingBox
        cursor="pointer"
        borderBottom="1px solid #e2e1e1"
        title="Update PIN"
        onClick={onOpen}
        description="Reset PIN"
        icon={
          <svg
            width="18"
            height="22"
            viewBox="0 0 18 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15 7.5H17C17.2652 7.5 17.5196 7.60536 17.7071 7.79289C17.8946 7.98043 18 8.23478 18 8.5V20.5C18 20.7652 17.8946 21.0196 17.7071 21.2071C17.5196 21.3946 17.2652 21.5 17 21.5H1C0.734784 21.5 0.48043 21.3946 0.292893 21.2071C0.105357 21.0196 0 20.7652 0 20.5V8.5C0 8.23478 0.105357 7.98043 0.292893 7.79289C0.48043 7.60536 0.734784 7.5 1 7.5H3V6.5C3 4.9087 3.63214 3.38258 4.75736 2.25736C5.88258 1.13214 7.4087 0.5 9 0.5C10.5913 0.5 12.1174 1.13214 13.2426 2.25736C14.3679 3.38258 15 4.9087 15 6.5V7.5ZM2 9.5V19.5H16V9.5H2ZM8 13.5H10V15.5H8V13.5ZM4 13.5H6V15.5H4V13.5ZM12 13.5H14V15.5H12V13.5ZM13 7.5V6.5C13 5.43913 12.5786 4.42172 11.8284 3.67157C11.0783 2.92143 10.0609 2.5 9 2.5C7.93913 2.5 6.92172 2.92143 6.17157 3.67157C5.42143 4.42172 5 5.43913 5 6.5V7.5H13Z"
              fill="#4D80E4"
            />
          </svg>
        }
      />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          mt="auto"
          rounded="12px"
          px="1rem"
          maxW={{ md: '480px !important' }}
          mx="auto">
          <ModalHeader mb="1rem" fontWeight="500" mt="1.2rem" fontSize="1.4rem" color="black">
            Update Pin
          </ModalHeader>
          <ModalBody id="update-form" as="form" onSubmit={handleSubmit(onSubmit)}>
            <Text mb="1rem" color="black">
              Old PIN
            </Text>
            <HStack w="full">
              <Controller
                control={control}
                name="old_pin"
                rules={{
                  required: { value: true, message: 'Old PIN is required' },
                  maxLength: { value: 6, message: 'Old PIN must be 6 digits' },
                  minLength: { value: 6, message: 'Old PIN must be 6 digits' }
                }}
                render={({ field: { onChange } }) => (
                  <PinInput
                    isInvalid={errors.otp}
                    size="lg"
                    onChange={onChange}
                    otp
                    mask
                    placeholder="">
                    {Array(6)
                      .fill('')
                      .map(() => (
                        <PinInputField color="black" />
                      ))}
                  </PinInput>
                )}
              />
            </HStack>
            <ErrorMessage isError={errors.otp && errors.otp.message} />
            <Text color="black" mt="2.4rem">
              New PIN
            </Text>
            <HStack w="full">
              <Controller
                control={control}
                name="new_pin"
                rules={{
                  required: { value: true, message: 'PIN is required' },
                  maxLength: { value: 6, message: 'PIN must be 6 digits' },
                  minLength: { value: 6, message: 'PIN must be 6 digits' }
                }}
                render={({ field: { onChange } }) => (
                  <PinInput
                    isInvalid={errors.pin}
                    size="lg"
                    onChange={onChange}
                    otp
                    mask
                    placeholder="">
                    {Array(6)
                      .fill('')
                      .map(() => (
                        <PinInputField color="black" />
                      ))}
                  </PinInput>
                )}
              />
            </HStack>{' '}
            <ErrorMessage isError={errors.pin && errors.pin.message} />
          </ModalBody>

          <ModalFooter>
            <Button form="update-form" type="submit" isFullWidth variant="blue">
              Update
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Layout>
  )
}

export { Security }
